import { defineMessages } from 'react-intl'

export default defineMessages({
  ScanandPayWith: {
    id: 'components.PaymentMethods.App.ScanandPayWith',
    defaultMessage: 'Scan and Pay With',
    description: '请修改',
  },
  Processing: {
    id: 'components.PaymentMethods.App.Processing',
    defaultMessage: 'Processing...',
    description: '请修改',
  },
  BacktoRetry: {
    id: 'components.PaymentMethods.App.BacktoRetry',
    defaultMessage: 'Retry',
    description: '请修改',
  },
  ProcessingDescription:{
    id: 'components.PaymentMethods.ProcessingDescription',
    defaultMessage:'Please continue to your transaction on',
    description:'请修改'
  },
  HighlightBotimName:{
    id: 'components.PaymentMethods.HighlightBotimName',
    defaultMessage:'Botim',
    description:'请修改'
  },
  HighlightPayByName:{
    id: 'components.PaymentMethods.HighlightPayByName',
    defaultMessage:'PayBy',
    description:'请修改'
  }
})
